import type { StaticDataType, StaticDataGroupProps, ContextInitialValueType } from './StaticData';
import StaticData, { StaticDataGroup  } from './StaticData';

export type { StaticDataType, StaticDataGroupProps, ContextInitialValueType };
export { StaticDataGroup };
export default StaticData;